import React from 'react';
import PropTypes from 'prop-types';
import { Card, Row, Col, Alert } from 'react-bootstrap-5';
import pluralize from 'pluralize';

export default class ImportPreview extends React.Component {
  static propTypes = {
    errors: PropTypes.array.isRequired,
    fieldColumnLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
    fileName: PropTypes.string.isRequired,
    objectName: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
  }

  fieldNames() {
    return this.props.fieldColumnLabels.join(', ');
  }

  render() {
    const { fileName, rowCount, objectName } = this.props;

    return (
      <>
        <p>
          The following fields will be imported into Buildout. If everything looks good, you can start your import.
        </p>
        <p className="fs-large mt-7 mb-2 text-uppercase text-muted">
          <strong className="fw-semibold">{fileName}</strong>
        </p>
        {this.renderErrors()}
        <Card className="mb-4">
          <Card.Body>
            <Row>
              <Col className="border-end" md={3} sm={4} xs={12}>
                <div className="separator-right">
                  <p>Buildout will import:</p>
                  <div>
                    <strong className="fw-semibold" name="rowCount">{pluralize(objectName, rowCount, true)}</strong>
                  </div>
                </div>
              </Col>
              <Col md={9} sm={8} xs={12}>
                <p>Buildout will import data from these fields:</p>
                <div>
                  <strong className="fw-semibold" name="fieldNames">{this.fieldNames()}</strong>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </>
    );
  }

  renderErrors() {
    if (this.props.errors.length === 0) return;

    return (
      <Alert variant="warning">
        <h6>
          <strong>Whoops -</strong> There were errors in your CSV mapping that prevented the import from starting.
        </h6>
        <ul>
          {this.props.errors.map((error, i) => <li key={i}>{error}</li>)}
        </ul>
      </Alert>
    );
  }
}
